export default __webpack_public_path__ + "static/media/COPD.8c239184.png";